export const config = {
    aplicacao: 'Copasa Spia',
    version: '1.0.0',
    build: '',
};